/**
 * Number of seconds before expiry to refresh the token.
 *
 * @type {number}
 */
export const AUTH_REFRESH_LEEWAY = 60 * 5;

export const PAYMENT_INTENT_STATUS_SUCCEEDED = "succeeded";

export const PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION = "requires_confirmation";
export const PAYMENT_INTENT_STATUS_REQUIRES_ACTION = "requires_action";
export const PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD = "requires_payment_method";

export const REQUIRES_ACTIONS = [
    PAYMENT_INTENT_STATUS_REQUIRES_ACTION,
    PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION,
    PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD
];
